/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMount, useUpdateEffect, usePrevious } from 'react-use';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import qs from 'qs';
import { Button, Avatar, ConfigProvider, Breadcrumb, Input, Divider } from 'antd';
import { withQuery } from '@/utils';
import * as actions from '@/models/productsPending/actions';
import * as selectors from '@/models/productsPending/selectors';
import { getTenantById } from '@/models/tenants/services';
import styles from './products.module.scss';
import ProductInfoDialog from '@/components/dialogs/ProductInfoDialog';
import PageableTable from '@/components/PageableTable';
import * as apis from '@/apis'
const { Search } = Input;
function getColumns({ showInfoDialog, Category, onSuccess }) {
  const dispatch = useDispatch();
  const isTenantMode = process.env.APP_MODE === 'tenant';
  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => (
        <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
      ),
    },
    {
      title: '企业名称',
      dataIndex: 'tenant',
      width: 150,
      render: (text, record) => (
        <span>{record?.tenant?.short_name}</span>
      ),
    },
    {
      title: '产品封面图',
      dataIndex: 'cover',
      width: 90,
      render: (val) => (
        <Avatar shape="square" size={56} className={styles.image} src={val} />
      ),
    },
    {
      title: '产品名',
      dataIndex: 'name',
      width: 150,
    },
    {
      title: '产品分类',
      dataIndex: 'name',
      width: 150,
      render: (text, record, idx) => (
        <div>
          {Category?.map(ele => { return (ele._id === record.category ? ele.name : "") })}
        </div>
      ),
    },
    {
      title: '状态',
      dataIndex: 'is_read',
      width: 90,
      render: (text, record, idx) => (
        <div>
          {record.is_read == 1 ? '已处理' : '未处理'}
        </div>
      ),
    },
    {
      title: '摘要信息',
      dataIndex: 'desc',
      render: (val) => {
        if (isTenantMode) {
          return '-';
        }

        return val;
      },
    },
    {
      title: '添加日期',
      dataIndex: 'createdAt',
      render: (val) => (
        <div style={{ whiteSpace: 'nowrap' }}>
          {dayjs(val).format('YYYY-MM-DD HH:mm:ss')}
        </div>
      ),
    },
    {
      title: '操作',
      render: (item) => {
        const setActiveAction = () => dispatch(actions.setActiveState(item._id, false, onSuccess))
        return (
          <div style={{ whiteSpace: 'nowrap' }}>
            {/* <a onClick={setActiveAction}>删除</a>
            <Divider type="vertical" /> */}
            <a
              onClick={showInfoDialog(
                `编辑产品 - ${item.name}`,
                item.tenant_id,
                item._id
              )}
            >
              编辑
            </a>
          </div>
        );
      },
    },
  ];
}

function ProductsPending(props) {
  const dispatch = useDispatch();
  const { query, history, match, location } = props;
  const tenantId = props.tenantId || match.params.id;
  const [tenant, setTenant] = useState(null);
  const [Category, setCategory] = useState([]);
  const [queryText, setQueryText] = useState("");
  console.log(3333333, JSON.stringify(query))
  const prevQuery = usePrevious(query);
  const limit = query.limit || 10;
  const offset = query.offset || 0;
  const [queryParams, setQueryParams] = useState({});
  const loading = useSelector(selectors.loadingSelector);
  const total = useSelector(selectors.totalSelector);
  const products = useSelector(selectors.entriesSelectors);
  const pagination = {
    showQuickJumper: true,
    total: total,
  };

  const fetch = useCallback((params = {}) => {
    params = { ...queryParams, ...params }
    params.offset = params.offset || offset;
    params.limit = params.limit || limit;
    setQueryParams(params)
    dispatch(actions.fetchList(params));
  }, []);

  const fetchCategory = async () => {
    const result = await apis.getProductCategory()
    setCategory(result.data || [])
  }
  const showInfoDialog = useCallback(
    (title, tenantId, id) => () => {
      dispatch(
        actions.showInfoDialog({
          title,
          tenant_id: tenantId,
          id,
          onSuccess
        })
      );
    },
    [query]
  );
  const onSearch = useCallback((keyword) => {
    query.keyword = keyword
    fetch(query);
  })
  const onChange = useCallback((e) => {
    setQueryText(e.target.value)
  })
  const handleTableChange = useCallback(
    (params) => {
      window.scrollTop = 0;
      const nextQuery = {
        ...query,
        // ...queryParams,
        ...params,
      };
      history.push(`${location.pathname}?${qs.stringify(nextQuery)}`);
    },
    [location, queryParams]
  );
  const onSuccess = useCallback(() => {
    query.keyword = queryText
    fetch(query);
  });
  const exportProduct = useCallback(() => {
    query.keyword = queryText
    const downloadUrl = apis.getProductDumpUrl(query);
    window.open(downloadUrl)
  });
  const columns = getColumns({ showInfoDialog, Category, onSuccess });

  useMount(() => {
    fetch(query);
    // fetchCategory()
  });

  // useEffect(() => {
  //   if (/^\/enterprises\//.test(location.pathname)) {
  //     getTenantById(tenantId).then((result) => setTenant(result));
  //   }
  // }, [tenantId]);

  useUpdateEffect(() => {
    if (prevQuery.offset !== query.offset) {
      window.scrollTop = 0;
      fetch(query);
    }
  });

  const customizeRenderEmpty = () => (
    <div className={styles.emptyTips}>
      <img className={styles.img} src={process.env.PUBLIC_URL + '/empty.svg'}></img>
      <div className={styles.text}>
        <div>暂无产品信息</div>
      </div>
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>

          <Breadcrumb.Item>
            待处理的产品</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          <Search
            placeholder="请输入关键词"
            allowClear
            enterButton
            value={queryText}
            onChange={onChange}
            style={{ width: 300, marginRight: 10 }}
            onSearch={onSearch}
          />
          {/* <Button onClick={showInfoDialog('添加产品', tenantId)} style={{ marginRight: 10 }}>添加产品</Button>
          <Button type="link" onClick={exportProduct} >下载</Button> */}
        </div>
      </div>

      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <PageableTable
          className={styles.table}
          columns={columns}
          dataSource={products.toJS()}
          pagination={pagination}
          total={total}
          limit={+limit}
          offset={+offset}
          onChange={handleTableChange}
          loading={loading}
        />
      </ConfigProvider>
      <ProductInfoDialog type="staff" />
    </div>
  );
}

export default withQuery(ProductsPending);
